import { Controller } from "stimulus"

export default class extends Controller {
    static values = { seconds: Number };
    static targets = ["output"];
    static classes = [ "stop","start"]

    connect() {
    
    }
    starttimer() {
        let that = this
        this.downloadTimer = setInterval(function () {
            if (that.timeleft <= 0) {
                clearInterval(that.downloadTimer);
                if (that.hasOutputTarget) {
                    that.outputTarget.innerHTML = "0";
                }
            } else {
                //console.log(timeleft);
                if (that.hasOutputTarget) {
                    that.outputTarget.innerHTML = that.timeleft;
                }
                else {
                    console.log("No target")
                }
            }
            that.timeleft -= 1;
        }, 1000);
    }

    start(event) {
        console.log("-------------------")
        console.log(this.downloadTimer);
        if (this.downloadTimer !== null) {
            if (this.stopped === false) {
                this.stopped = true;
                clearInterval(this.downloadTimer);
                if (this.timeleft <= 0)
                {
                    this.timeleft = this.secondsValue;
                    this.element.classList.remove(this.stoppedClass)
                    this.element.classList.add(this.resetClass)
                    this.element.classList.remove(this.countingClass)

                }
                else
                {
                    this.element.classList.add(this.stoppedClass)
                    this.element.classList.remove(this.resetClass)
                    this.element.classList.remove(this.countingClass)

                }
            }
            else
            {
                if (this.timeleft <= 0) {
                    this.timeleft = this.secondsValue;
                    this.element.classList.remove(this.stoppedClass)
                    this.element.classList.add(this.resetClass)
                    this.element.classList.remove(this.countingClass)

                }
                else {
                    this.element.classList.remove(this.stoppedClass)
                    this.element.classList.remove(this.resetClass)
                    this.element.classList.add(this.countingClass)
                    this.starttimer();
                }
            }
        }
        else {
            this.timeleft = this.secondsValue;
            this.starttimer();
            this.element.classList.remove(this.stoppedClass)
            this.element.classList.remove(this.resetClass)
            this.element.classList.add(this.countingClass)

        }
    };
    
}
